import React from "react";
import { inject, observer } from "mobx-react";
import { Helmet } from "react-helmet-async";
import withStyles from "react-jss";
import Container from "reactstrap/lib/Container";
import { generateUrl } from "Services/withDefaultParams";
import Metrika from "Services/Metrika";
import { isMainSiteCode } from "Utils/siteConfig";
import configRouters from "Configs/routes";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import {
	EVENT_ACTION_CLICK_FLAT_BUTTON,
	EVENT_ACTION_CLICK_OFFICE_BUTTON,
} from "Constants/metriks/GoogleActions";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import TopProviderContainer from "Containers/TopProviderContainer";
import RecentlyConnectedTariffsContainer from "Containers/RecentlyConnectedTariffsContainer";
import Districts from "Containers/DistrictsContainer";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import OneClick from "Containers/OneClick";

const styles = (theme) => ({
	benefits: {
		paddingBottom: "60px",
	},
	"@media ( min-width: 1200px) and (max-width: 1438px)": {
		benefits: {
			paddingBottom: "60px",
		},
	},
	"@media ( min-width: 765px) and (max-width: 1200px)": {
		benefits: {
			paddingBottom: "40px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		benefits: {
			display: "none",
		},
	},
});

@inject("ApplicationModel")
@observer
class ToHome extends React.Component {
	handleChoose(value) {
		if (value == "home") {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_FLAT_BUTTON
			);
		} else {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_OFFICE_BUTTON
			);
		}
	}

	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.OrderToHome.route, this.props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		const siteCode = this.props.ApplicationModel.siteCode;

		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<React.Fragment>
					<AddressSearchContainer
						callback={(value) => this.handleChoose(value)}
						sendGAWhenFulled={true}
						isOrdersToHome={true}
						hideTitle={true}
					/>
					<SeoBlockHOC route={this.props.route} placeText="TopProvider">
						<TopProviderContainer backgroundNone={true} />
					</SeoBlockHOC>

					<RecentlyConnectedTariffsContainer
						{...this.props}
						isOrderToHome={true}
						pageName="search_address"
					/>
					<Container>
						<OneClick />
						<DeclinationContainerNew>
							<Districts />
						</DeclinationContainerNew>
					</Container>
				</React.Fragment>
			</>
		);
	}
}

export default withStyles(styles)(ToHome);
